<template>
  <div
    id="PTpage"
    class="partner-dark-layout partner-white-responsive partner-demo"
    :class="[getMobileTableClass, toggleMenuOpen ? 'menu-open' : 'menu-close', (make || makesub) ? 'partner-popup-open' : '']"
    v-if="userData && gameCount && partnerLevelList"
  >
    <header id="header" class="tophead partner-tophead">
      <div class="mobiletop">
        <a class="mobile-logo" @click="onChangeTab('partnerMain')">
          <h1 class="using-site-info logo">
            <i class="fi fi-rr-playing-cards"></i>
            {{ (siteIdInfo && siteIdInfo.siteName) || (userData && userData.joinDomain) || 'Partner' }}
          </h1>
        </a>
        <div class="langWrap" @mouseover="showMenuLang = true" @mouseleave="showMenuLang = false">
          <button class="langT">
            <span v-if="$i18n.locale === 'ko'"><img src="@/assets/img/korea.svg" /><span class="langbox">KR</span></span>
            <span v-if="$i18n.locale === 'en'"><img src="@/assets/img/en.svg" /><span class="langbox">EN</span></span>
            <span v-if="$i18n.locale === 'vn'"><img src="@/assets/img/vn.svg" /><span class="langbox">VN</span></span>
            <span v-if="$i18n.locale === 'mn'"><img src="@/assets/img/mn.svg" class="mn" /><span class="langbox">MN</span></span>
          </button>
          <div class="langB" v-if="showMenuLang">
            <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')"><img src="@/assets/img/korea.svg" /><span>KR</span></a>
            <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')"><img src="@/assets/img/en.svg" /><span>EN</span></a>
            <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')"><img src="@/assets/img/vn.svg" /><span>VN</span></a>
            <a href="#" :class="{'on': $i18n.locale === 'mn'}" @click="changeLocale('mn')"><img src="@/assets/img/mn.svg" class="mn" /><span>MN</span></a>
          </div>
        </div>
      </div>

      <button type="button" class="mMenu" @click="toggleTab">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>

      <div id="PTheadWrap" class="header-upper">
        <div class="topInfo-wrap">
          <ul class="coninpointPT" v-if="userData">
            <li class="coinpoint">
              <div class="topBtn">
                <a @click="goPageByName('partnerCashList')"><em>{{ $t('front.cash.changesInMoney') }}</em></a>
                <a @click="goPageByName('charge')"><em>{{ $t('front.cash.toCharge') }}</em></a>
                <a @click="goPageByName('exchange')"><em>{{ $t('front.cash.toExchange') }}</em></a>
                <a @click="goPageByName('point')"><em>{{ $t('front.cash.rollingGold') }}</em></a>
                <a v-if="!isHiddenDomain" @click="goPageByName('qna')"><em>{{ $t('front.common.inquiry') }}</em></a>
                <a @click="goPageByName('noticeList')"><em>{{ $t('front.common.notice') }}</em></a>
                <a @click="goPageByName('msg')"><em>{{ $t('front.common.note') }}</em></a>
              </div>
            </li>
          </ul>
          <div class="topInfo">
            <div>
              <em><img src="@/assets/img/icon_user.svg" /><i>{{ $t('front.common.member') }}</i></em>
              <span>{{ thousand(mainTopInfo.userCnt || 0) }}</span>
            </div>
            <div>
              <em><img src="@/assets/img/icon_money.svg" /><i>{{ $t('front.cash.nav3') }}</i></em>
              <span>{{ thousand(mainTopInfo.totalCashAmt || 0) }}</span>
            </div>
            <div>
              <em><img src="@/assets/img/icon_point.svg" /><i>{{ $t('front.cash.nav4') }}</i></em>
              <span>{{ thousand(mainTopInfo.totalPointAmt || 0) }}</span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <button
      v-if="toggleMenuOpen && !make && !makesub"
      type="button"
      class="mobile-side-menu-open"
      @click="toggleTab"
      aria-label="메뉴 열기"
      title="메뉴 열기"
    >
      <span aria-hidden="true">☰</span>
    </button>

    <div id="PTbodyWrap">
      <div v-if="!make && !makesub" class="PTtabWrap navWrap" :class="[toggleMenuOpen ? 'menu-open' : 'menu-close']">
        <nav>
          <div class="nav-upper">
            <div class="user-info-wrap top">
              <div class="tempBox-wrap first">
                <a class="partner-logo" @click="onChangeTab('partnerMain')">
                  <h1 class="using-site-info logo">
                    {{userData.memNick}}
                  </h1>
                </a>
                <div class="logout-wrap">
                  <button type="button" class="logout-link" @click="goPageByName('infoEdit')">
                    <i class="fi fi-rr-settings"></i>
                  </button>
                  <button type="button" class="logout-link logout-btn" @click="signOut">로그아웃</button>
                  <button
                    type="button"
                    class="navBtn mobile-side-menu-close"
                    @click="toggleTab"
                    aria-label="메뉴 닫기"
                    title="메뉴 닫기"
                  >
                    <i class="fi fi-rr-angle-circle-left"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="nav-upper2">
            <div class="user-info-wrap top">
              <div class="tempBox">
                <h2>MAIN INFO</h2>
                <div class="langWrap" @mouseover="showMenuLang = true" @mouseleave="showMenuLang = false">
                  <button class="langT">
                    <span v-if="$i18n.locale === 'ko'"><img src="@/assets/img/korea.svg" /><span class="langbox">KR</span></span>
                    <span v-if="$i18n.locale === 'en'"><img src="@/assets/img/en.svg" /><span class="langbox">EN</span></span>
                    <span v-if="$i18n.locale === 'vn'"><img src="@/assets/img/vn.svg" /><span class="langbox">VN</span></span>
                    <span v-if="$i18n.locale === 'mn'"><img src="@/assets/img/mn.svg" class="mn" /><span class="langbox">MN</span></span>
                  </button>
                  <div class="langB" v-if="showMenuLang">
                    <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')"><img src="@/assets/img/korea.svg" /><span>KR</span></a>
                    <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')"><img src="@/assets/img/en.svg" /><span>EN</span></a>
                    <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')"><img src="@/assets/img/vn.svg" /><span>VN</span></a>
                    <a href="#" :class="{'on': $i18n.locale === 'mn'}" @click="changeLocale('mn')"><img src="@/assets/img/mn.svg" class="mn" /><span>MN</span></a>
                  </div>
                </div>
              </div>
              <div class="contents">
                <div class="mId">{{ $t('front.common.account') }}</div>
                <div class="logout-name">
                  {{ userData.memNick }}
                </div>
              </div>
            </div>
            <div class="user-info-wrap credit-wrap">
              <div class="tempBox-wrap pt">
                <div class="tempBox-item">
                  <div class="tempBox">
                    <div class="title">{{ $t('front.cash.nav3') }}</div>
                    <div class="content-val">{{ thousand(userData.cashAmt ? userData.cashAmt.toString() : '0') }}</div>
                  </div>
                  <div class="tempBox point">
                    <div class="title">{{ $t('front.cash.nav4') }}</div>
                    <div class="content-val">{{ thousand(userData.pointAmt ? userData.pointAmt.toString() : '0') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 태블릿/모바일 전용: 상단 헤더 바로가기 메뉴 -->
          <div class="sidebar-mobile-shortcuts">
            <p class="sidebar-mobile-shortcuts__title">빠른 메뉴</p>
            <div class="sidebar-mobile-shortcuts__grid">
              <a @click="goPageByName('partnerCashList')">
                <i class="fi fi-rr-wallet"></i>
                <span>{{ $t('front.cash.changesInMoney') }}</span>
              </a>
              <a @click="goPageByName('charge')">
                <i class="fi fi-rr-money-bill-transfer"></i>
                <span>{{ $t('front.cash.toCharge') }}</span>
              </a>
              <a @click="goPageByName('exchange')">
                <i class="fi fi-rr-exchange"></i>
                <span>{{ $t('front.cash.toExchange') }}</span>
              </a>
              <a @click="goPageByName('point')">
                <i class="fi fi-rr-refresh"></i>
                <span>{{ $t('front.cash.rollingGold') }}</span>
              </a>
              <a v-if="!isHiddenDomain" @click="goPageByName('qna')">
                <i class="fi fi-rr-comment-question"></i>
                <span>{{ $t('front.common.inquiry') }}</span>
              </a>
              <a @click="goPageByName('noticeList')">
                <i class="fi fi-rr-megaphone"></i>
                <span>{{ $t('front.common.notice') }}</span>
              </a>
              <a @click="goPageByName('msg')">
                <i class="fi fi-rr-envelope"></i>
                <span>{{ $t('front.common.note') }}</span>
              </a>
            </div>
          </div>

          <div class="btnwrap lower-btnwrap">
            <h4 :class="{ 'menu_on' : menu_D }">
              {{ $t('front.common.goTo') }}
              <img src="@/assets/img/menu_arrow.svg" @click="menuOpen_D()" />
            </h4>
            <div class="moneyBtn" :class="{ 'menu_on' : menu_D }">
              <div class="flex lower-action-list">
                <a class="createBtnPT grn flex_c" @click="onChangePartnerAddPopupSub(userData)" v-if="userData.partnerLevel !== 'NORMAL'">{{ $t('front.common.lowerPart') }}</a>
                <a class="createBtnPT grn flex_c" @click="onChangePartnerAddPopup('makeTab2')" v-if="userData.partnerLevel !== 'NORMAL' && userData.joinDomain !== 'or.zeno101.com'">{{ $t('front.common.createMember') }}</a>
              </div>
            </div>
          </div>

          <ul class="menu-wrap nav-bottom">
            <li>
              <ul class="content-wrap" :class="{ active: currentTab === 'partnerMain' }">
                <li class="menu-title" @click="onChangeTab('partnerMain')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg><span class="text">{{ $t('front.common.main') }}</span></div>
                </li>
              </ul>
            </li>

            <li v-if="!isPartnerMember" :class="{ disabled: userData.partnerLevel === 'PTN_8' }">
              <ul class="content-wrap" :class="{ active: pList }">
                <li class="menu-title" @click="menuToggle('pList')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="7" r="3"/><path d="M3 21v-3a6 6 0 0 1 12 0v3M16 4a3 3 0 0 1 0 6M18 13a5 5 0 0 1 3 5v3"/></svg><span class="text">{{ $t('front.common.partnerList') }}</span></div>
                  <i class="fas fa-chevron-right"></i>
                </li>
                <li class="menu-contents">
                  <ul>
                    <li><a class="supMenu" @click="onChangeTab('partnerList')" :class="{ active: currentTab === 'partnerList' }">{{ $t('front.common.allPartner') }}</a></li>
                    <template v-for="pt in partnerLevelList" :key="pt.code">
                      <li v-if="pt.code !== 'NORMAL'">
                        <a class="supMenu" @click="onChangeTab('partnerListLevel' + pt.code)" :class="{ active: currentTab === 'partnerListLevel' + pt.code }">{{ $t(pt.codeName) }} {{ $t('front.common.allList') }}</a>
                      </li>
                    </template>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <ul class="content-wrap" :class="{ active: uList }">
                <li class="menu-title" @click="menuToggle('uList')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/></svg><span class="text">{{ $t('front.common.membership') }}</span></div>
                  <i class="fas fa-chevron-right"></i>
                </li>
                <li class="menu-contents">
                  <ul>
                    <li><a class="supMenu" @click="onChangeTab('partnerUserList')" :class="{ active: currentTab === 'partnerUserList' }">{{ $t('front.common.memberList') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('onlinelist')" :class="{ active: currentTab === 'onlinelist' }">{{ $t('front.common.access') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <ul class="content-wrap" :class="{ active: bList }">
                <li class="menu-title" @click="menuToggle('bList')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="7" width="14" height="14" rx="2"/><path d="M8 7V3h13v14h-2M12 11l3 3-3 3-3-3z"/></svg><span class="text">{{ $t('front.common.betNRoll') }}</span></div>
                  <i class="fas fa-chevron-right"></i>
                </li>
                <li class="menu-contents">
                  <ul>
                    <li><a class="supMenu" @click="onChangeTab('bettingtotal')" :class="{ active: currentTab === 'bettingtotal' }">{{ $t('front.common.betStatusAll') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('bettingcasino')" :class="{ active: currentTab === 'bettingcasino' }">{{ $t('front.common.betStatusCasino') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('bettingslot')" :class="{ active: currentTab === 'bettingslot' }">{{ $t('front.common.betStatusSlot') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('bettingDetailListCasino')" :class="{ active: currentTab === 'bettingDetailListCasino' }">{{ $t('front.common.betDetailListCasino') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('bettingDetailListSlot')" :class="{ active: currentTab === 'bettingDetailListSlot' }">{{ $t('front.common.betDetailListSlot') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <ul class="content-wrap" :class="{ active: gList }">
                <li class="menu-title" @click="menuToggle('gList')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v18h18M7 17v-5M12 17V8M17 17V4"/></svg><span class="text">{{ $t('front.common.gameRecord') }}</span></div>
                  <i class="fas fa-chevron-right"></i>
                </li>
                <li class="menu-contents">
                  <ul>
                    <li><a class="supMenu" @click="onChangeTab('statDateBet')" :class="{ active: currentTab === 'statDateBet' }">{{ $t('front.common.dailyBet') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('statDateUsers')" :class="{ active: currentTab === 'statDateUsers' }">{{ $t('front.common.dailyUser') }}</a></li>
                    <li><a class="supMenu" @click="onChangeTab('statDateAgent')" :class="{ active: currentTab === 'statDateAgent' }">{{ $t('front.common.dailyPartner') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <ul class="content-wrap" :class="{ active: currentTab === 'cashListMy' }">
                <li class="menu-title" @click="onChangeTab('cashListMy')">
                  <div class="text-wrap"><svg class="menu-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="15" rx="2"/><path d="M3 8h18M21 12h-6v5h6M17 14.5h1"/></svg><span class="text">{{ $t('front.cash.changesInMoney') }}</span></div>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      <div class="PTboardwrap">
        <div class="">
          <!-- <div class="currentPT">
            <ul class="strheadPT">
              <li><h3 class="pagename2">현황</h3></li>
              <li class="ptUser"><span>{{$t('front.stributor.bottomPT')}}</span><span class="strnum" >{{summaryNew ? thousand(summaryNew.partnerCnt) : 0 }}</span></li>
              <li class="ptUser"><span>{{$t('front.stributor.bottomU')}}</span><span class="strnum" >{{summaryNew ? thousand(summaryNew.botMemCnt) : 0}}</span></li>
              <li class="ptUser"><span>{{$t('front.stributor.inUsers')}}</span><span class="strnum" >{{summaryNew ? thousand(summaryNew.totalMemCnt) : 0}}</span></li>
              <li class="ptUser"><span>{{$t('front.stributor.todayJoin')}}</span><span class="strnum" >{{summaryNew ? thousand(summaryNew.todayJoincnt) : 0}}</span></li>
            </ul>
          </div> -->
          <router-view :key="$route.fullPath" ></router-view>
          <!------------------------------------------------------------------------------->
          <div v-if="make" class="moveWrap makeWrap">
            <div class="makeWraphead">
              <ul class="groupTab">
                <!--li @click="currentTab2 = 'makeTab1'" :class="{'current': currentTab2 === 'makeTab1'}" v-if="newPartner.partnerLevel !== 'PTN_5' && userData.partnerLevel !== 'PTN_5'">파트너</li-->
                <li @click="currentTab2 = 'makeTab2'" :class="{'current': currentTab2 === 'makeTab2'}">{{ $t('front.common.member') }}</li>
                <li @click="currentTab2 = 'makeTab4'" :class="{'current': currentTab2 === 'makeTab4'}">{{ $t('front.common.groupMember') }}</li>
              </ul>
              <a class="close" @click="onChangePartnerAddPopup"><img src="@/assets/img/icon_cancel.png" /></a>
              <div v-if="currentTab2 == 'makeTab1'">
                 <h4 v-if="makeTab == 'taba'">
                    파트너 생성<span>생성 파트너 등급 :
                    <template v-if="newPartnerLevel.codeName === '총본사'">
                      대본
                    </template>
                    <template v-else-if="newPartnerLevel.codeName === '대본사'">
                      본사
                    </template>
                    <template v-else-if="newPartnerLevel.codeName === '부본사'">
                      부본
                    </template>
                    <template v-else>
                      {{newPartnerLevel.codeName}}
                    </template>
                    </span>
                 </h4>
                 <h4 v-if="makeTab == 'tabb'">게임별 요율설정</h4>
                 <!--div class="stepWrap">
                   <span class="step on"><em></em>파트너생성</span>
                   <span class="stepLine" :class="{'on' : makeTab == 'tabb'}"></span>
                   <span class="step" :class="{'on' : makeTab == 'tabb'}"><em></em>요율설정</span>
                 </div-->
              </div>
              <h4 v-if="currentTab2 == 'makeTab2'">
                {{ $t('front.common.makeMember') }}<span>{{ $t('front.common.recommandId') }} : {{newPartner.recommenderId}}</span>
              </h4>
              <h4 v-if="currentTab2 == 'makeTab3'">요율설정</h4>
              <h4 v-if="currentTab2 == 'makeTab4'">{{ $t('front.common.makeGroupMember') }} <span>{{ $t('front.common.recommandId') }} : {{newPartner.recommenderId}}</span></h4>
            </div>
            <div class="makeWrapbody" v-if="currentTab2 === 'makeTab1' && newPartner.partnerLevel !== 'PTN_5' && userData.partnerLevel !== 'PTN_5' ">
              <div v-if="makeTab == 'taba'">
                 <table class="part">
                   <colgroup>
                     <col width="40%"/>
                     <col width="60%"/>
                   </colgroup>
                   <tr>
                     <th>아이디</th>
                     <td><input class="in" name="newMemId" type="text" v-model="newPartner.memId" autocomplete="off" role="presentation"/>
                       <button class="checkBtn" @click="onCheckMemId(newPartner.memId, newPartner)">중복체크</button>
                    </td>
                   </tr>
                   <tr>
                     <th>비밀번호</th>
                     <td><input class="in" name="newMemPass" type="password" v-model="newPartner.memPass" autocomplete="off"/></td>
                   </tr>
                   <tr>
                     <th>닉네임</th>
                     <td>
                      <input class="in" type="text" v-model="newPartner.memNick"/>
                       <button class="checkBtn" @click="onCheckMemNick(newPartner.memNick, newPartner)">중복체크</button>
                    </td>
                   </tr>
                   <tr>
                     <th>출금 비밀번호</th>
                     <td><input class="in password" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" maxlength="4" type="text" v-model="newPartner.cashOutPass"/></td>
                   </tr>
                   <tr>
                     <th>생성파트너등급</th>
                     <td>
                        <template v-if="newPartnerLevel.codeName === '총본사'">
                         대본
                       </template>
                       <template v-else-if="newPartnerLevel.codeName === '대본사'">
                         본사
                       </template>
                       <template v-else-if="newPartnerLevel.codeName === '부본사'">
                         부본
                       </template>
                       <template v-else>
                         {{newPartnerLevel.codeName}}
                       </template>
                     </td>
                   </tr>
                   <tr>
                     <th>계좌정보</th>
                     <td class="accountInfo">
                       <bank-list :className="'in'" @onChange="onChangeBank"></bank-list>
                       <input class="in" type="text" v-model="newPartner.bankAcc"/>
                     </td>
                   </tr>
                   <tr>
                     <th>이름</th>
                     <td><input class="in" type="text" v-model="newPartner.memName"/></td>
                   </tr>
                   <tr>
                     <th>전화번호</th>
                     <td><input class="in" type="text" v-model="newPartner.memPhone"/></td>
                   </tr>
                 </table>
                 <div class="btnWrap">
                    <a class="btn" @click="onAddPartnerSubmit">{{$t('front.stributor.save')}}</a>
                    <!--a class="btn" @click="next('tabb')">다음</a-->
                 </div>
              </div>
              <!--div v-if="makeTab == 'tabb'" class="rate">
                 <div>
                   <p class="name">{{$t('front.stributor.roll')}}(%)</p>
                   <ul>
                     <li v-for="(item) in rateInfo" v-bind:key="item">
                       {{item.cateCodeName}}
                     </li>
                   </ul>
                   <ul>
                     <li v-for="(item) in rateInfo" v-bind:key="item">
                       <a class="rbnt">최대값 : {{item.pointRate}}</a>
                       <a class="rbnt">최소값 : 0</a>
                     </li>
                   </ul>
                   <ul>
                     <li v-for="(item) in newPartner.rateInfo.rateList" v-bind:key="item">
                       <input type="text" v-model="item.pointRate" >
                     </li>
                   </ul>
                 </div>
                 <div>
                   <p class="name">{{$t('front.stributor.lose')}}(%)</p>
                   <ul>
                     <li v-for="(item) in rateInfo" v-bind:key="item">
                       {{item.cateCodeName}}
                     </li>
                   </ul>
                   <ul>
                     <li v-for="(item) in rateInfo" v-bind:key="item">
                       <a class="rbnt">최대값 : {{item.loseRate}}</a>
                       <a class="rbnt">최소값 : 0</a>
                     </li>
                   </ul>
                   <ul>
                     <li v-for="(item) in newPartner.rateInfo.rateList" v-bind:key="item">
                       <input type="text" v-model="item.loseRate" >
                     </li>
                   </ul>
                 </div>
                 <div class="btnWrap">
                   <a class="btn" @click="next('taba')">이전</a>
                   <a class="btn" @click="onAddPartnerSubmit">{{$t('front.stributor.save')}}</a>
                 </div>
              </div-->
            </div>

            <div class="makeWrapbody" v-if="currentTab2 == 'makeTab2'">
              <table class="part">
                <colgroup>
                  <col width="40%"/>
                  <col width="60%"/>
                </colgroup>
                <tr>
                  <th>{{ $t('front.common.memId') }}</th>
                  <td><input class="in" type="text" autocomplete="off" v-model="newMember.memId"/>
                     <button class="checkBtn" @click="onCheckMemId(newMember.memId, newMember)">{{ $t('front.common.multiCheck') }}</button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.password') }}</th>
                  <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPass"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.passwordCheck') }}</th>
                  <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPassCheck"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.tel') }}</th>
                  <td><input class="in" type="text" v-model="newMember.memPhone"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.nickName') }}</th>
                  <td><input class="in" type="text" v-model="newMember.memNick"/>
                     <button class="checkBtn" @click="onCheckMemNick(newMember.memNick, newMember)">{{ $t('front.common.multiCheck') }}</button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.recommandId') }}</th>
                  <td>
                     {{newPartner.recommenderId}}
                     <input class="in" type="hidden" v-model="newMember.recommenderId"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.stributor.name') }}</th>
                  <td><input class="in" type="text" v-model="newMember.memName"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.cash.withdrawPassword') }}</th>
                  <td><input class="in password" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" maxlength="4" pattern="[0-9]*" v-model="newMember.cashOutPass" inputmode="numeric"  /></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.accountInfo') }}</th>
                  <td class="accountInfo">
                    <bank-list :className="'in'" @onChange="onChangeBankMember"></bank-list>
                    <input class="in w45w" type="text" v-model="newMember.bankacc" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" />
                  </td>
                </tr>
              </table>
              <div class="btnWrap">
                <a class="btn" @click="newMemberSignup()">{{ $t('front.board.reg') }}</a>
              </div>
            </div>

            <div class="makeWrapbody" v-if="currentTab2 == 'makeTab3'">
               <div>
                 <p class="name">내요율</p>
                 <div class="scroll mb40">
                    <table class="rolllose">
                      <tr>
                       <th></th>
                       <th v-if="gameCount['casino']">{{$t('front.gnb.casino')}}</th>
                       <th v-if="gameCount['hc-casino']">{{$t('front.gnb.hotelcasino')}}</th>
                       <th v-if="gameCount['slot']">{{$t('front.gnb.slot')}}</th>
                       <th v-if="gameCount['sports']">{{$t('front.gnb.sport')}}</th>
                       <template v-if="gameCount['mini-game'] || gameCount['mini game']">
                          <th>미니게임</th>
                       </template>
                      </tr>
                      <tr>
                       <th>{{$t('front.stributor.roll')}}(%)</th>
                       <td v-if="gameCount['casino']">{{myRate.casinoPR}}</td>
                       <td v-if="gameCount['hc-casino']">{{myRate.hcasinoPR}}</td>
                       <td v-if="gameCount['slot']">{{myRate.slotPR}}</td>
                       <td v-if="gameCount['sports']">{{myRate.sportPR}}</td>
                       <template v-if="gameCount['mini-game'] || gameCount['mini game']">
                          <td>{{myRate.miniPR}}</td>
                       </template>
                      </tr>
                      <tr>
                       <th>{{$t('front.stributor.lose')}}(%)</th>
                       <td v-if="gameCount['casino']">{{myRate.casinoLR}}</td>
                       <td v-if="gameCount['hc-casino']">{{myRate.hcasinoLR}}</td>
                       <td v-if="gameCount['slot']">{{myRate.slotLR}}</td>
                       <td v-if="gameCount['sports']">{{myRate.sportLR}}</td>
                       <template v-if="gameCount['mini-game'] || gameCount['mini game']">
                          <td>{{myRate.miniLR}}</td>
                       </template>
                      </tr>
                    </table>
                 </div>
             </div>
             <div>
                <p class="name">하부회원 요율조정</p>
                <div class="scroll">
                  <table class="rolllose2">
                    <tr>
                      <th>{{$t('front.common.memId')}}<em>({{$t('front.common.nickName')}})</em></th>
                      <th>분류</th>
                      <th v-if="gameCount['casino']">{{$t('front.gnb.casino')}}</th>
                      <th v-if="gameCount['hc-casino']">{{$t('front.gnb.hotelcasino')}}</th>
                      <th v-if="gameCount['slot']">{{$t('front.gnb.slot')}}</th>
                      <th v-if="gameCount['sports']">{{$t('front.gnb.sport')}}</th>
                      <template v-if="gameCount['mini-game'] || gameCount['mini game']">
                        <th>미니게임</th>
                        <th>하이로우88</th>
                      </template>
                    </tr>
                    <template v-if="myChildrenRate.length">
                      <template v-for="item in myChildrenRate" :key="item.memId">
                       <tr>
                          <td rowspan="2">{{item.memId}}<em>({{item.memNick}})</em></td>
                          <th>{{$t('front.stributor.roll')}}(%)</th>
                          <td v-if="gameCount['casino']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.casinoPRError}" type="text" v-model="item.casinoPR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['hc-casino']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.hcasinoPRError}" type="text" v-model="item.hcasinoPR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['slot']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.slotPRError}" type="text" v-model="item.slotPR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['sports']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.sportPRError}" type="text" v-model="item.sportPR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['mini-game']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.miniPRError}" type="text" v-model="item.miniPR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['mini-game']">
                           <button class="detailSet" @click="toggleDetailSet(item)">세부설정</button>
                          </td>
                          <div class="detailSetWrap" v-if="isSelectedRow(item)">
                           <table>
                              <tbody>
                                <tr>
                                  <td rowspan="2" class="tableheadside">일반</td>
                                  <td>롤링</td>
                                  <td>
                                   <button class="btnm">최소<i>(1.05)</i></button>
                                   <input>
                                   <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>롤링</td>
                                  <td>
                                   <button class="btnm">최소<i>(1.05)</i></button>
                                   <input>
                                   <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td rowspan="2" class="tableheadside">조합</td>
                                  <td>루징</td>
                                  <td>
                                   <button class="btnm">최소<i>(1.05)</i></button>
                                   <input>
                                   <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>루징</td>
                                  <td>
                                   <button class="btnm">최소<i>(1.05)</i></button>
                                   <input>
                                   <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                              </tbody>
                           </table>
                           <button class="detailSetSave">저장</button>
                           <span @click="toggleDetailSet" class="detailClose">×</span>
                          </div>
                       </tr>
                       <tr>
                          <th>{{$t('front.stributor.lose')}}(%)</th>
                          <td v-if="gameCount['casino']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.casinoLRError}" type="text" v-model="item.casinoLR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['hc-casino']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.hcasinoPRError}" type="text" v-model="item.hcasinoLR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['slot']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.slotLRError}" type="text" v-model="item.slotLR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['sports']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.sportLRError}" type="text" v-model="item.sportLR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['mini-game']">
                             <button class="btnm">최소<i>(1.05)</i></button>
                             <input @change="onChangeChildrenRate(item)" :class="{'error': item.miniLRError}" type="text" v-model="item.miniLR" :disabled="userData.updId == 'royal77'">
                             <button class="btnx">최대<i>(5.05)</i></button>
                          </td>
                          <td v-if="gameCount['mini-game']">
                           <button class="detailSet" @click="toggleDetailSetlosing(item)">세부설정</button>
                          </td>
                          <div class="detailSetWrap detailLosing" v-if="isSelectedRowlosing(item)">
                           <table>
                              <tbody>
                                <tr>
                                  <td rowspan="2" class="tableheadside">일반</td>
                                  <td>롤링</td>
                                  <td>
                                    <button class="btnm">최소<i>(1.05)</i></button>
                                    <input>
                                    <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>롤링</td>
                                  <td>
                                    <button class="btnm">최소<i>(1.05)</i></button>
                                    <input>
                                    <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td rowspan="2" class="tableheadside">조합</td>
                                  <td>루징</td>
                                  <td>
                                    <button class="btnm">최소<i>(1.05)</i></button>
                                    <input>
                                    <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>루징</td>
                                  <td>
                                    <button class="btnm">최소<i>(1.05)</i></button>
                                    <input>
                                    <button class="btnx">최대<i>(5.05)</i></button>
                                  </td>
                                </tr>
                              </tbody>
                           </table>
                           <button class="detailSetSave">저장</button>
                           <span @click="toggleDetailSetlosing" class="detailClose">×</span>
                          </div>
                       </tr>
                      </template>
                    </template>
                  </table>

                </div>
             </div>
             <p>하부회원의 최대 요율은 내 상위요율을 넘을 수 없습니다. 최소요율은 해당회원의 하부 최대 요율보다 낮을 수 없습니다.</p>
             <div class="btnWrap">
                <a class="btn" @click="onUpdateChildrenRate">{{$t('front.stributor.save')}}</a>
             </div>
            </div>

            <div class="makeWrapbody" v-if="currentTab2 == 'makeTab4'">
              <table class="part">
                <colgroup>
                  <col width="40%"/>
                  <col width="60%"/>
                </colgroup>
                <tr>
                  <th>{{ $t('front.common.memId') }}</th>
                  <td>
                     <input class="add" type="text" autocomplete="off" v-model="newMember.memId"/>
                     <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdStart"> ~
                     <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdEnd">
                     <button class="checkBtn" @click="groupMemIdCheck(groupMemIdStart, groupMemIdEnd)">{{ $t('front.common.multiCheck') }}</button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.password') }}</th>
                  <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPass"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.passwordCheck') }}</th>
                  <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPassCheck"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.tel') }}</th>
                  <td><input class="in" type="text" v-model="newMember.memPhone"/></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.nickName') }}</th>
                  <td>
                     <input class="add" type="text" v-model="newMember.memNick"/>
                    <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdStart"> ~
                    <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdEnd">
                     <button class="checkBtn" @click="groupMemNickCheck(groupMemIdStart, groupMemIdEnd)">{{ $t('front.common.multiCheck') }}</button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.recommandId') }}</th>
                  <td>
                     {{newPartner.recommenderId}}
                     <input class="in" type="hidden" v-model="newMember.recommenderId"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.stributor.name') }}</th>
                  <td>
                    <input class="add" type="text" v-model="newMember.memName"/>
                    <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdStart"> ~
                    <input type="text" pattern="[0-9]*" name="" class="add2" v-model="groupMemIdEnd">
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('front.cash.withdrawPassword') }}</th>
                  <td><input class="in password" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" maxlength="4" pattern="[0-9]*" v-model="newMember.cashOutPass" inputmode="numeric"  /></td>
                </tr>
                <tr>
                  <th>{{ $t('front.common.accountInfo') }}</th>
                  <td class="accountInfo">
                    <bank-list :className="'in'" @onChange="onChangeBankMember"></bank-list>
                    <input class="in w45w" type="text" v-model="newMember.bankacc" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" />
                  </td>
                </tr>
              </table>
              <div class="btnWrap">
                <a class="btn" @click="newMemberGroupSignup()">{{ $t('front.board.reg') }}</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
    <div v-if="make && !makesub" class="makePopupDim" @click="make = false"></div>
    <div v-if="makesub" class="makePopupDim" @click="makesub = false"></div>
    <div v-if="makesub" class="moveWrap2 makePopup">
      <div class="tabmenu_make moveWraphead">
        <ul>
          <li @click="makesubTab = 'makeTab1'" :class="{'current': makesubTab == 'makeTab1'}">{{ $t('front.common.partner') }}</li>
          <li @click="makesubTab = 'makeTab2'" :class="{'current': makesubTab == 'makeTab2'}">{{ $t('front.common.member') }}</li>
        </ul>
        <a class="close" @click="makesub = false"><img src="@/assets/img/icon_cancel.png" /></a>
      </div>
      <div class="tabcont_make moveWrapbody" v-if="makesubTab == 'makeTab1' && newPartner.partnerLevel !== 'PTN_7'" >
        <h4>{{ $t('front.common.makePartner') }}</h4>
        <table class="part">
          <colgroup>
            <col width="20%"/>
            <col width="30%"/>
            <col width="20%"/>
            <col width="30%"/>
          </colgroup>
          <tr>
            <th>{{ $t('front.common.memId') }}</th>
            <td><input class="in" name="newMemId" type="text" v-model="newPartner.memId" autocomplete="off" role="presentation"/></td>
            <th>{{ $t('front.common.password') }}</th>
            <td><input class="in" name="newMemPass" type="password" v-model="newPartner.memPass" autocomplete="off"/></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.nickName') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memNick" /></td>
            <th>{{ $t('front.cash.withdrawPassword') }}</th>
            <td><input class="in password" pattern="[0-9]*" type="text" v-model="newPartner.cashOutPass" /></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.recommandId') }}</th>
            <td>{{newPartner.recommenderId}}({{newPartner.partnerLevelName}})</td>
            <th>{{ $t('front.common.accountInfo') }}</th>
            <td class="accountInfo">
              <bank-list :className="'in'" @onChange="onChangeBank"></bank-list>
              <input class="in w45w" type="text" v-model="newPartner.bankAcc"/>
            </td>
          </tr>
          <tr>
            <th>{{ $t('front.stributor.name') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memName" /></td>
            <th>{{ $t('front.common.tel') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memPhone" /></td>
          </tr>
        </table>
        <a class="btn" @click="onAddPartnerSubmit">{{ $t('front.board.reg') }}</a>
      </div>

      <div class="tabcont_make moveWrapbody" v-if="makesubTab == 'makeTab2'">
        <h4>{{ $t('front.common.makeMember') }}</h4>
        <table class="part">
          <colgroup>
            <col width="20%"/>
            <col width="30%"/>
            <col width="20%"/>
            <col width="30%"/>
          </colgroup>
          <tr>
            <th>{{ $t('front.common.memId') }}</th>
            <td><input class="in" type="text" autocomplete="off" v-model="newMember.memId"/></td>
            <th>{{ $t('front.common.cashOutPass') }}</th>
            <td><input class="in password" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" maxlength="4" pattern="[0-9]*" v-model="newMember.cashOutPass" inputmode="numeric"  /></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.password') }}</th>
            <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPass"/></td>
            <th>{{ $t('front.common.tel') }}</th>
            <td><input class="in" type="text" v-model="newMember.memPhone"/></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.nickName') }}</th>
            <td><input class="in" type="text" v-model="newMember.memNick"/></td>
            <th>{{ $t('front.common.recommandId') }}</th>
            <td>{{newPartner.recommenderId}}({{newPartner.partnerLevelName}})
              <input class="in" type="hidden" v-model="newMember.recommenderId"/>
            </td>
          </tr>
          <tr>
            <th>{{ $t('front.stributor.name') }}</th>
            <td><input class="in" type="text" v-model="newMember.memName"/></td>
            <th>{{ $t('front.common.accountInfo') }}</th>
            <td class="accountInfo">
              <bank-list :className="'in'" @onChange="onChangeBankMember"></bank-list>
              <input class="in w45w" type="text" v-model="newMember.bankacc" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" />
            </td>
          </tr>
        </table>
        <a class="btn" @click="newMemberSignup()">{{ $t('front.board.reg') }}</a>
      </div>
    </div>
</template>

<script>
import { setLangCookie } from '@/libs/auth-helper'
import {
  partnerJoin, partnerLevels, partnerRates, retailUpdate, retailMemRate
} from '@/api/retail'
import {
  isValidOnlyNumber,
  isValidOnlyPhoneNumber,
  isValidPassword,
  isValidPasswordPartner,
  isValidUserId,
  thousand
} from '@/libs/utils'
import { mapState } from 'vuex'
import BankList from '@/components/ui/BankList.vue'
import { PARTNER_LEVEL_NAME, PARTNER_MOBILE_TABLE_SITE } from '@/libs/constants'
import { partnerJoinV2 } from '@/api/v2/partner'
import { checkMemId, checkMemNick, signUp } from '@/api/member'
import store from '@/store'
import { getTopInfo } from '@/api/v2/top'
export default {
  name: 'Partner',
  components: { BankList },
  computed: {
    ...mapState([
      'siteIdInfo',
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode',
      'unReadQnaCount',
      'unReadMessageCount'
    ]),
    isPartnerMember () {
      return this.userData.loginType === 'P_NORMAL'
    },
    isHiddenDomain () {
      const hiddenDomains = ['']
      const currentHost = window.location.hostname
      return hiddenDomains.includes(currentHost)
    },
    getMobileTableClass () {
      const siteId = process.env.VUE_APP_SITE_ID || ''
      let mobileTableClass = ''
      if (PARTNER_MOBILE_TABLE_SITE.includes(siteId)) {
        mobileTableClass = 'mobileTable'
      }
      return mobileTableClass
    }
  },
  data () {
    return {
      pList: false,
      uList: false,
      bList: false,
      gList: false,
      showMenuLang: false,
      currentTab: this.$route.name,
      currentTab2: 'makeTab2',
      makeTab: 'taba',
      summary: {},
      rate: {},
      move: false,
      make: false,
      makesub: false,
      makesubTab: 'makeTab1',
      menu_D: true,
      myRate: {},
      myChildrenRate: [],
      selectedRow: null,
      selectedRowlosing: null,
      detailSet: false,
      newPartner: {
        memId: '',
        memPass: '',
        memNick: '',
        memPhone: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        rateInfo: {
          rateList: []
        },
        rateGroup: {},
        isCheckMemId: false,
        isCheckMemNick: false
      },
      defaultNewPartner: {
        memId: '',
        memPass: '',
        memNick: '',
        memPhone: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        rateInfo: {
          rateList: []
        },
        rateGroup: {},
        isCheckMemId: false,
        isCheckMemNick: false
      },
      newMember: {
        memId: '',
        memPass: '',
        memPassCheck: '',
        memPhone: '',
        memNick: '',
        memName: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        memLevel: '1',
        partSendYn: 'N',
        firstBetConfYn: 'N',
        memStatus: 0,
        isCheckMemId: false,
        isCheckMemNick: false
      },
      defaultMember: {
        memId: '',
        memPass: '',
        memPassCheck: '',
        memPhone: '',
        memNick: '',
        memName: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        memLevel: '1',
        partSendYn: 'N',
        firstBetConfYn: 'N',
        memStatus: 0,
        isCheckMemId: false,
        isCheckMemNick: false
      },
      groupMemIdStart: '',
      groupMemIdEnd: '',
      groupListCheck: false,
      groupListCheckNick: false,
      groupList: [],
      rateInfo: [],
      newPartnerLevel: {},
      partnerLevelList: [],
      partnerLevelObject: {},
      partnerList: [],
      summaryNew: null,
      isMenuOpen: false,
      toggleMenuOpen: true,
      mainTopInfo: {
        userCnt: '',
        totalCashAmt: '',
        totalPointAmt: '',
        casinoRate: '',
        slotRate: ''
      }
    }
  },
  async created () {
    // router-view가 바뀌어 공통 레이아웃이 다시 생성돼도,
    // 현재 페이지가 속한 큰 메뉴는 열린 상태로 복원한다.
    this.syncOpenMenuByTab(this.$route.name)

    this.emitter.emit('Loading', true)
    await this.loadGameGroupCode()
    await this.loadCommonCode()
    this.loadTopInfo()
    // eslint-disable-next-line camelcase
    const menu_D = localStorage.getItem('menu_D')
    // eslint-disable-next-line camelcase
    this.menu_D = menu_D === null ? true : JSON.parse(menu_D)
    await this.getPartnerLevels()
    this.newPartnerLevel = this.partnerLevelList[0]
    this.emitter.emit('Loading', false)

    this.emitter.on('ChangePay', () => {
      this.loadTopInfo()
    })
  },
  watch: {
    '$route.name' (name) {
      this.currentTab = name
      this.syncOpenMenuByTab(name)
    },
    async userData (newVal, oldVal) {
      if (newVal) {
        await this.getPartnerRateForNewPartner()
      }
    },
    'newPartner.partnerLevel': function (newLevel) {
      if (this.newPartner.partnerLevel === 'PTN_5' || this.userData.partnerLevel !== 'PTN_5') {
        this.currentTab2 = 'makeTab2'
      } else {
        this.currentTab2 = 'makeTab1'
      }
    }
  },
  methods: {
    gnbReset () {
      this.showMenuLang = false
    },
    gnbMenuOpen (type) {
      this.gnbReset()
      if (type === 'lang') {
        this.showMenuLang = true
      }
    },
    changeLocale (lang) {
      if (this.$i18n.locale === lang) {
        return
      } else {
        this.$i18n.locale = lang
      }
      setLangCookie(lang)
    },
    loadTopInfo () {
      getTopInfo({}).then(res => {
        console.log('getMainTopInfo : ', res)
        const result = res.data
        if (result.resultCode === '0') {
          this.mainTopInfo = { ...result.data.mainTopInfo }
        }
      })
    },
    menuToggle (type) {
      const menuKeys = ['pList', 'uList', 'bList', 'gList']
      const nextOpen = !this[type]

      menuKeys.forEach(key => {
        this[key] = false
      })

      this[type] = nextOpen
    },
    menuTogglee (type) {
      this.menuToggle(type)
    },
    syncOpenMenuByTab (tabName) {
      const name = String(tabName || '')
      const menuKeys = ['pList', 'uList', 'bList', 'gList']

      menuKeys.forEach(key => {
        this[key] = false
      })

      if (name === 'partnerList' || name.indexOf('partnerListLevel') === 0) {
        this.pList = true
      } else if (name === 'partnerUserList' || name === 'onlinelist') {
        this.uList = true
      } else if ([
        'bettingtotal',
        'bettingcasino',
        'bettingslot',
        'bettingDetailListCasino',
        'bettingDetailListSlot'
      ].includes(name)) {
        this.bList = true
      } else if ([
        'statDateBet',
        'statDateUsers',
        'statDateAgent'
      ].includes(name)) {
        this.gList = true
      }
    },
    loadGameGroupCode () {
      return store.dispatch('storeGameGroupCodes')
    },
    loadCommonCode () {
      return store.dispatch('storeCommonCode')
    },
    onCheckMemNick (memNick, obj) {
      if (memNick) {
        const params = {
          memNick
        }
        return checkMemNick(params).then(res => {
          console.log(res)
          const result = res.data
          if (result.resultCode === '0') {
            console.log('ok')
            obj.isCheckMemNick = true
            alert('닉네임이 등록이 가능합니다.')
            return true
          } else {
            obj.isCheckMemNick = false
            alert('중복된 닉네임이 존재합니다.')
            return false
          }
        })
      } else {
        obj.isCheckMemNick = false
        alert('닉네임을 입력해주세요')
        return false
      }
    },
    onCheckMemId (memId, obj) {
      if (memId) {
        const params = {
          memId
        }
        checkMemId(params).then(res => {
          console.log(res)
          const result = res.data
          if (result.resultCode === '0') {
            console.log('ok')
            obj.isCheckMemId = true
            alert('아이디 등록이 가능합니다.')
          } else {
            obj.isCheckMemId = false
            alert('중복된 아이디가 존재합니다.')
          }
        })
      } else {
        obj.isCheckMemId = false
        alert('아이디를 입력해주세요')
      }
    },
    menuOpen_D () {
      this.menu_D = !this.menu_D
      localStorage.setItem('menu_D', JSON.stringify(this.menu_D))
    },
    next (tab) {
      if (!this.newPartner.isCheckMemId) {
        alert('아이디 중복체크를 해주세요')
        return false
      }
      if (!this.newPartner.isCheckMemNick) {
        alert('닉네임 중복체크를 해주세요')
        return false
      }

      this.makeTab = tab
    },
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    },
    toggleTab () {
      this.toggleMenuOpen = !this.toggleMenuOpen
    },
    onChangeBankMember (value) {
      this.newMember.bank = value
    },
    isMemberSignupValidate () {
      const data = this.newMember
      for (const key of Object.keys(data)) {
        const value = data[key]
        if (key === 'memId') {
          if (value === '') {
            this.onAlert('warningart', 'front.member.emptyMemId')
            return false
          }

          if (!isValidUserId(value)) {
            this.onAlert('warningart', 'api.U101')
            return false
          }
        }

        if (key === 'memPassCheck') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.compareMemPass')
            return false
          }
        }

        if (key === 'memPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemPass')
            return false
          }

          if (!isValidPassword(value) || value.length > 20) {
            this.onAlert('warningart', 'api.U102')
            return false
          }
        }
        if (key === 'memPhone') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemTel')
            return false
          }

          if (!isValidOnlyPhoneNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidMemTel')
            return false
          }
        }
        if (key === 'memNick') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemNick')
            return false
          }

          if (value.length > 20 || value.length < 3) {
            this.onAlert('warningart', 'api.U105')
            return false
          }
        }
        if (key === 'recommenderId') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyRecommenderId')
            return false
          }
        }
        if (key === 'memName') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankAccountName')
            return false
          }
        }
        if (key === 'cashOutPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyCashOutPass')
            return false
          }

          if (!isValidOnlyNumber(value) || value.length !== 4) {
            this.onAlert('warningart', 'api.U103')
            return false
          }
        }
        if (key === 'bank') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankName')
            return false
          }
        }
        if (key === 'bankacc') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankNumber')
            return false
          }

          if (!isValidOnlyNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidBankNumber')
            return false
          }
        }
        if (data.memPass !== data.memPassCheck) {
          this.onAlert('warningart', 'front.member.compareMemPass')
          return false
        }
      }
      return true
    },
    handlePartnerViewportResize () {
      const isDesktop = window.innerWidth > 1092

      if (!isDesktop && this.lastViewportIsDesktop) {
        this.toggleMenuOpen = true
      }

      this.lastViewportIsDesktop = isDesktop
    },
    newMemberSignup () {
      if (!this.newMember.isCheckMemId) {
        alert('아이디 중복체크를 해주세요')
        return false
      }
      if (!this.newMember.isCheckMemNick) {
        alert('닉네임 중복체크를 해주세요')
        return false
      }
      this.emitter.emit('Loading', true)
      this.newMember.recommenderId = this.newPartner.recommenderId
      if (this.isMemberSignupValidate()) {
        this.newMember.memPhone = this.newMember.memPhone.toString()
        signUp(this.newMember).then(async response => {
          const result = response.data
          if (result.resultCode === '0') {
            await this.onCheck('front.member.completeSignup')
            this.makesub = false
            this.newMember = {
              ...this.defaultMember
            }
          } else {
            this.onAlert('warningart', 'api.' + result.resultCode)
          }
        }).catch(err => {
          console.error('singup err : ', err)
        })
      }
      this.emitter.emit('Loading', false)
    },
    async newMemberGroupSignup () {
      // const newMem = { ...this.newMember }

      if (!this.groupListCheck) {
        alert('아이디 중복체크를 해주세요')
        return false
      }
      if (!this.groupListCheckNick) {
        alert('닉네임 중복체크를 해주세요')
        return false
      }
      this.emitter.emit('Loading', true)
      this.newMember.recommenderId = this.newPartner.recommenderId
      if (this.isMemberSignupValidate()) {
        this.newMember.memPhone = this.newMember.memPhone.toString()

        // console.log(this.newMember)

        let successCnt = 0
        for (const extend of this.groupList) {
          // this.newMember.memId = newMem.memId + extend
          // this.newMember.memNick = newMem.memNick + extend
          //
          const newMem = {
            ...this.newMember,
            memId: this.newMember.memId + extend,
            memNick: this.newMember.memNick + extend,
            memName: this.newMember.memName + extend
          }

          console.log(newMem)
          await signUp(newMem).then(async response => {
            console.log(response)
            const result = response.data
            if (result.resultCode === '0') {
              // await this.onCheck('front.member.completeSignup')
              // this.makesub = false
              // this.newMember = {
              //   ...this.defaultMember
              // }
              successCnt += 1
            } else {
              // this.onAlert('warningart', 'api.' + result.resultCode)
              console.error(result.resultCode, result.resultMessage)
            }
          }).catch(err => {
            console.error('singup err : ', err)
          })
        }

        console.log(this.groupList.length, successCnt)

        this.emitter.emit('Loading', false)
        if (this.groupList.length === successCnt) {
          await this.onCheck('front.member.completeSignup')
          location.reload()
        } else {
          await this.onAlert('warningart', '확인 후 다시시도해주세요')
        }
      }
      this.emitter.emit('Loading', false)
    },
    onChangeTab (name, param) {
      const targetTab = (param && param.code) ? param.code : name

      this.currentTab = targetTab
      // 하위 메뉴 클릭 직후에도 상위 메뉴의 열린 상태를 유지한다.
      this.syncOpenMenuByTab(targetTab)

      this.goPageByName(name, param)
    },
    toggleDetailSet (item) {
      if (this.isSelectedRow(item)) {
        this.selectedRow = null
      } else {
        this.selectedRow = item
      }
    },
    isSelectedRow (item) {
      return this.selectedRow === item
    },
    toggleDetailSetlosing (item) {
      if (this.isSelectedRow(item)) {
        this.selectedRowlosing = null
      } else {
        this.selectedRowlosing = item
      }
    },
    isSelectedRowlosing (item) {
      return this.selectedRowlosing === item
    },
    onChangeChildrenRate (item) {
      const casinoPR = Number(item.casinoPR)
      if (isNaN(casinoPR)) {
        item.casinoPRError = true
      }
      if (casinoPR || casinoPR === 0) {
        const maxCasinoPR = Number(item.maxCasinoPR)
        const minCasinoPR = Number(item.minCasinoPR)
        if (maxCasinoPR < casinoPR || minCasinoPR > casinoPR) {
          item.casinoPRError = true
        } else {
          item.casinoPRError = false
        }
      }

      const hcasinoPR = Number(item.hcasinoPR)
      if (isNaN(hcasinoPR)) {
        item.hcasinoPRError = true
      }
      if (hcasinoPR || hcasinoPR === 0) {
        const maxHcasinoPR = Number(item.maxHcasinoPR)
        const minHcasinoPR = Number(item.minHcasinoPR)
        console.log(hcasinoPR, maxHcasinoPR, minHcasinoPR)
        if (maxHcasinoPR < hcasinoPR || minHcasinoPR > hcasinoPR) {
          item.hcasinoPRError = true
        } else {
          item.hcasinoPRError = false
        }
        console.log(item.hcasinoPRError)
      }

      const slotPR = Number(item.slotPR)
      if (isNaN(slotPR)) {
        item.slotPRError = true
      }
      if (slotPR || slotPR === 0) {
        const maxSlotPR = Number(item.maxSlotPR)
        const minSlotPR = Number(item.minSlotPR)
        if (maxSlotPR < slotPR || minSlotPR > slotPR) {
          item.slotPRError = true
        } else {
          item.slotPRError = false
        }
      }

      const miniPR = Number(item.miniPR)
      if (isNaN(miniPR)) {
        item.miniPRError = true
      }
      if (miniPR || miniPR === 0) {
        const maxMiniPR = Number(item.maxMiniPR)
        const minMiniPR = Number(item.minMiniPR)
        if (maxMiniPR < miniPR || minMiniPR > miniPR) {
          item.miniPRError = true
        } else {
          item.miniPRError = false
        }
      }

      const sportPR = Number(item.sportPR)
      if (isNaN(sportPR)) {
        item.sportPRError = true
      }
      if (sportPR || sportPR === 0) {
        const maxSportPR = Number(item.maxSportPR)
        const minSportPR = Number(item.minSportPR)
        if (maxSportPR < sportPR || minSportPR > sportPR) {
          item.sportPRError = true
        } else {
          item.sportPRError = false
        }
      }

      const casinoLR = Number(item.casinoLR)
      if (isNaN(casinoLR)) {
        item.casinoLRError = true
      }
      if (casinoLR || casinoLR === 0) {
        const maxCasinoLR = Number(item.maxCasinoLR)
        const minCasinoLR = Number(item.minCasinoLR)
        if (maxCasinoLR < casinoLR || minCasinoLR > casinoLR) {
          item.casinoLRError = true
        } else {
          item.casinoLRError = false
        }
      }

      const hcasinoLR = Number(item.hcasinoLR)
      if (isNaN(hcasinoLR)) {
        item.hcasinoLRError = true
      }
      if (hcasinoLR || hcasinoLR === 0) {
        const maxHcasinoLR = Number(item.maxHcasinoLR)
        const minHcasinoLR = Number(item.minHcasinoLR)
        if (maxHcasinoLR < hcasinoLR || minHcasinoLR > hcasinoLR) {
          item.hcasinoLRError = true
        } else {
          item.hcasinoLRError = false
        }
      }

      const slotLR = Number(item.slotLR)
      if (isNaN(slotLR)) {
        item.slotLRError = true
      }
      if (slotLR || slotLR === 0) {
        const maxSlotLR = Number(item.maxSlotLR)
        const minSlotLR = Number(item.minSlotLR)
        if (maxSlotLR < slotLR || minSlotLR > slotLR) {
          item.slotLRError = true
        } else {
          item.slotLRError = false
        }
      }

      const miniLR = Number(item.miniLR)
      if (isNaN(miniLR)) {
        item.miniLRError = true
      }
      if (miniLR || miniLR === 0) {
        const maxMiniLR = Number(item.maxMiniLR)
        const minMiniLR = Number(item.minMiniLR)
        if (maxMiniLR < miniLR || minMiniLR > miniLR) {
          item.miniLRError = true
        } else {
          item.miniLRError = false
        }
      }

      const sportLR = Number(item.sportLR)
      if (isNaN(sportLR)) {
        item.sportLRError = true
      }
      if (sportLR || sportLR === 0) {
        const maxSportLR = Number(item.maxSportLR)
        const minSportLR = Number(item.minSportLR)
        if (maxSportLR < sportLR || minSportLR > sportLR) {
          item.sportLRError = true
        } else {
          item.sportLRError = false
        }
      }
    },
    async onUpdateChildrenRate () {
      const rateList = this.myChildrenRate
      console.log(rateList)

      for (let i = 0, iLen = rateList.length; i < iLen; i++) {
        const item = rateList[i]
        if (item.casinoLRError ||
          item.casinoPRError ||
          item.hcasinoPRError ||
          item.hcasinoLRError ||
          item.slotLRError ||
          item.slotPRError ||
          item.miniLRError ||
          item.miniPRError ||
          item.sportLRError ||
          item.sportPRError
        ) {
          return
        }
      }

      const confirm = await this.onConfirm('front.common.confirmSave')
      if (confirm) {
        const param = {
          siteId: '',
          memId: '',
          rateList: rateList
        }

        this.emitter.emit('Loading', true)
        retailUpdate(param).then(res => {
          this.emitter.emit('Loading', false)
          const data = res.data
          if (data.resultCode === '0') {
            this.onCheck('front.recommender.complete')
            this.onLoadRate()
          }
        })
      }
    },
    onLoadRate () {
      retailMemRate({}).then(res => {
        const data = res.data
        console.log('retailMemRate : ', data)
        if (data.resultCode === '0') {
          this.myRate = data.data.myCategoryRate
          this.myChildrenRate = data.data.botCategoryRateList
        }
      })
    },
    thousand,
    getPartnerLevels () {
      return partnerLevels({}).then(res => {
        const result = res.data
        console.log('partnerLevels : ', res.data)
        if (result.resultCode === '0') {
          this.partnerLevelList = result.data.list
          this.newPartnerLevel = result.data.list[0]

          const partnerObj = {}
          for (let i = 0; i < this.partnerLevelList.length; i++) {
            const item = this.partnerLevelList[i]
            const code = item.code
            const codeName = item.codeName

            if (!partnerObj[code]) {
              partnerObj[code] = codeName
            }
          }

          this.partnerLevelObject = partnerObj
        }
      })
    },
    onChangePartnerAddPopup (type) {
      this.make = !this.make
      this.currentTab2 = type
      if (this.make) {
        this.newPartner.recommenderId = this.userData.memId
        const list = this.rateInfo
        this.newPartner.rateInfo.rateList = []
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          this.newPartner.rateInfo.rateList.push({
            category: item.category,
            cateCode: item.cateCode,
            pointRate: item.pointRate,
            loseRate: item.loseRate
          })
        }
      }
      console.log(this.newPartner)
    },
    getPartnerLevelCode (partner) {
      if (!partner) {
        return ''
      }
      return partner.partnerLevel || partner.myLevel || ''
    },
    getPartnerLevelName (partner) {
      const partnerLevel = this.getPartnerLevelCode(partner)
      if (!partnerLevel) {
        return ''
      }
      return partner.partnerLevelName || partner.myLevelName || this.partnerLevelObject[partnerLevel] || PARTNER_LEVEL_NAME[partnerLevel] || ''
    },
    getPartnerRateGroup (list) {
      const rateGroup = {}

      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        const vendorCode = item.vendorCode
        const commonCode = this.commonCodeByCode[vendorCode]
        if (!commonCode) {
          continue
        }

        let groupCode = commonCode.groupCode
        const groupCodeName = commonCode.groupCodeName
        if (groupCode === 'minigame') {
          groupCode = 'mini'
        }
        if (groupCode === 'casino' && groupCodeName && groupCodeName.indexOf('HC-') > -1) {
          groupCode = 'hcasino'
        }
        if (groupCode) {
          rateGroup[groupCode] = {
            ...item
          }
          rateGroup[groupCode][`${groupCode}PR`] = '0.0'
          rateGroup[groupCode][`${groupCode}LR`] = '0.0'
        }
      }

      return rateGroup
    },
    getPartnerJoinV2ReqData (reqData) {
      const rateGroup = {}
      const sourceRateGroup = reqData.rateGroup || {}

      for (const groupCode in sourceRateGroup) {
        const item = sourceRateGroup[groupCode]
        rateGroup[`${groupCode}PR`] = item[`${groupCode}PR`]
        rateGroup[`${groupCode}LR`] = item[`${groupCode}LR`]
      }

      return {
        ...reqData,
        rateGroup
      }
    },
    async onChangePartnerAddPopupSub (currentPartner) {
      console.log(currentPartner)
      if (!currentPartner) {
        return
      }
      this.makesubTab = 'makeTab1'
      this.makesub = !this.makesub
      if (this.makesub) {
        const partnerLevel = this.getPartnerLevelCode(currentPartner)
        this.newPartner.recommenderId = currentPartner.memId
        this.newPartner.partnerLevel = partnerLevel
        this.newPartner.partnerLevelName = this.getPartnerLevelName(currentPartner)
        const rateMaxMinList = await this.getPartnerRateForNewPartner(currentPartner.memId)
        this.newPartner.rateGroup = this.getPartnerRateGroup(rateMaxMinList || [])

        const list = this.rateInfo
        this.newPartner.rateInfo.rateList = []
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            this.newPartner.rateInfo.rateList.push({
              category: item.category,
              cateCode: item.cateCode,
              pointRate: item.pointRate,
              loseRate: item.loseRate
            })
          }
        }
      }
    },
    getPartnerRateForNewPartner (memId) {
      console.log(this.siteIdInfo)
      const params = {
        siteId: this.siteIdInfo.siteId,
        memId: memId || this.userData.memId
      }
      console.log('req요율 : ', params)
      return partnerRates(params).then(res => {
        const result = res.data
        console.log('res요율 : ', result)
        if (result.resultCode === '0') {
          if (memId) {
            return result.data.rateMaxMinList || []
          }
          this.rateInfo = result.data.rateInfo
        }
      })
    },
    onAddPartnerSubmit () {
      const reqData = { ...this.newPartner }
      if (!reqData.memId) {
        this.onAlert('warningart', 'front.member.emptyMemId')
        return false
      }

      if (!isValidUserId(reqData.memId)) {
        this.onAlert('warningart', 'api.U101')
        return false
      }

      if (!reqData.memPass) {
        this.onAlert('warningart', 'front.member.emptyMemPass')
        return false
      }
      if (!isValidPasswordPartner(reqData.memPass) || reqData.memPass.length > 20) {
        this.onAlert('warningart', 'api.U102')
        return false
      }

      if (!reqData.memNick) {
        this.onAlert('warningart', 'front.member.emptyMemNick')
        return false
      }
      if (!reqData.cashOutPass) {
        this.onAlert('warningart', 'front.member.emptyCashOutPass')
        return false
      }
      if (!reqData.bank) {
        this.onAlert('warningart', 'front.member.emptyBankName')
        return false
      }
      if (!reqData.bankAcc) {
        this.onAlert('warningart', 'front.member.emptyBankNumber')
        return false
      }
      if (!reqData.memName) {
        this.onAlert('warningart', 'front.member.emptyMemName')
        return false
      }
      if (!reqData.memPhone) {
        this.onAlert('warningart', 'front.member.emptyMemTel')
        return false
      }

      this.emitter.emit('Loading', true)

      const partnerJoinApi = this.makesub ? partnerJoinV2(this.getPartnerJoinV2ReqData(reqData)) : partnerJoin(reqData)

      return partnerJoinApi.then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.onCheck('하위파트너 생성신청이 완료되었습니다. 관리자에서 승인되면 가입처리가 완료됩니다.')
          if (this.make) {
            this.onChangePartnerAddPopup()
          }
          if (this.makesub) {
            this.makesub = false
          }
          this.newPartner = { ...this.defaultNewPartner }
          this.emitter.emit('Loading', false)
        } else {
          this.emitter.emit('Loading', false)
          this.onAlert('warningart', result.resultMessage)
        }
      })
    },
    onChangeBank (value) {
      this.newPartner.bank = value
    },
    async memIdCheck (memId) {
      const reqData = {
        memId
      }
      const res = await checkMemId(reqData)
      if (res.resultCode === '0') {
        if (res.data.member.memId) {
          alert('중복된 회원입니다. 다시 입력해주세요.')
          this.joinData.memId = ''
          return false
        }
      } else {
        alert('사용가능합니다.')
        return true
      }
    },
    async memIdCheckForGroup (memId) {
      const reqData = {
        memId
      }
      const res = await checkMemId(reqData)
      console.log(res)
      if (res.data.resultCode === '0') {
        return true
      } else {
        return false
      }
    },
    async groupMemIdCheck (startValue, endValue) {
      this.groupList = []
      const start = Number(startValue)
      const end = Number(endValue)
      if (!this.newMember.memId) {
        alert('아이디를 입력해주세요')
        this.groupListCheck = false
        return false
      }

      // const isMemIdValid = await this.memIdCheck(this.newMember.memId)
      // if (!isMemIdValid) {
      //   this.groupListCheck = false
      //   return false
      // }

      this.groupListCheck = true

      this.groupListCheck = this.groupCheck(start, end)
      if (!this.groupListCheck) {
        return false
      }

      for (let i = start; i <= end; i++) {
        if (i < 10) {
          if (i === start) {
            this.groupMemIdStart = '0' + i.toString()
          }
          if (i === end) {
            this.groupMemIdEnd = '0' + i.toString()
          }
          this.groupList.push('0' + i.toString())
        } else {
          this.groupList.push(i.toString())
        }
      }

      for (const item of this.groupList) {
        console.log(this.newMember.memId + item)
        const isMemIdValid = await this.memIdCheckForGroup(this.newMember.memId + item)
        console.log(isMemIdValid)
        if (!isMemIdValid) {
          alert('중복된 회원입니다. 다시 입력해주세요.')
          this.groupListCheck = false
          return false
        }
      }

      console.log(this.groupList)
      if (this.groupListCheck) {
        alert('정상적으로 확인하였습니다.')
      }
    },
    async groupMemNickCheck (startValue, endValue) {
      const start = Number(startValue)
      const end = Number(endValue)
      if (!this.newMember.memNick) {
        alert('닉네임을 입력해주세요')
        this.groupListCheckNick = false
        return false
      }

      const isMemNickValid = await this.onCheckMemNick(this.newMember.memNick, this.newMember)
      console.log(isMemNickValid)
      if (!isMemNickValid) {
        this.groupListCheckNick = false
        return false
      }

      this.groupListCheckNick = true

      this.groupListCheckNick = this.groupCheck(start, end)

      for (let i = start; i <= end; i++) {
        if (i < 10) {
          if (i === start) {
            this.groupMemIdStart = '0' + i.toString()
          }
          if (i === end) {
            this.groupMemIdEnd = '0' + i.toString()
          }
          // this.groupList.push('0' + i.toString())
        } else {
          // this.groupList.push(i.toString())
        }
      }
      if (this.groupListCheckNick) {
        alert('정상적으로 확인하였습니다.')
      }
    },
    groupCheck (startValue, endValue) {
      const start = parseInt(startValue)
      const end = parseInt(endValue)
      console.log(start, end)

      if (isNaN(start) || isNaN(end)) {
        alert('숫자만 입력해주세요')
        return false
      }

      if (start >= end) {
        alert('뒷자리가 앞자리보다 커야 합니다.')
        return false
      }

      if ((end - start) > 9) {
        alert('최대 10명까지 가입이 가능합니다.')
        return false
      }
      return true
    }
  }
}
</script>
<style>
footer { display: none !important; }
.tab-content.current{display: inherit;}
.blc {color: #2F4DF2 !important;font-weight: bold;}
.rdc {color: #e1534e;font-weight: bold;}
.strTable.more {/*border: 2px solid #e5972d;*/width: 100%;}
.moreT img {margin-right: 6px;}
.strTable {width: 100%;text-align: center;vertical-align: middle;font-size: 12px; overflow: hidden;border-collapse: collapse;border-spacing: 0;box-sizing: border-box;}
.strTable.moreTable {border-left: 0;border-right: 0;}
.strTable th {height: 40px;background: #EEF0F5;color: #000000;vertical-align: middle;}
.strTable td {height: 35px;background: #FBFCFD;vertical-align: middle;border-bottom: solid 1px #E9EAEF;white-space: nowrap;color: #000000;overflow: hidden;text-overflow: ellipsis;position: relative;}
.strTable td:last-child {border-right: 0;}
.money {text-align: left;}
.money li {padding: 0 10px;height: 30px;display: flex;align-items: center;justify-content: space-between; letter-spacing: -0.6px;}
.money li:nth-child(4) {background: #fff; color: #F75D4C; background-color: #ffedee;
}
.moreTable .money li:nth-child(4) {background: #fff; color: #F75D4C;}
/* .moreBtn {box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: #2F4DF2;position: absolute;top: 50%;left:5px;transform: translate(0, -50%);width: 18px;height: 18px;cursor: pointer;transition: all 0.7s ease;font-size: 22px;border:1px solid #2F4DF2;border-radius: 3px;}
.moreBtn img {height: 22px;transform: rotate(90deg);transition: all 0.7s ease;} */

.strTable td:first-child,
.strTable td:first-child .name {position: relative;}
/*.line .strTable td:first-child::before {
   content: '';
   width: 1px;
   height: 100%;
   background: #E9EAEF;
   position: absolute;
   left: 20px;
   top: 0;
}
.line .strTable .strTable td:first-child::before {left: 30px;}
.line .strTable .strTable .strTable td:first-child::before {left: 40px;}
.line .strTable .strTable .strTable .strTable td:first-child::before {left: 50px;}
.line .strTable .strTable .strTable .strTable .strTable td:first-child::before {left: 60px;}
.line .strTable .strTable .strTable .strTable .strTable .strTable td:first-child::before {left: 70px;}
.line .strTable td:first-child .name::before {
  content: '';
  width: 10px;
  height: 1px;
  background: #E9EAEF;
  position: absolute;
  left: 20px;
  top: 50%;
}*/
.line .strTable .strTable td:first-child .name::before {left: 30px;}
.line .strTable .strTable .strTable td:first-child .name::before {left: 40px;}
.line .strTable .strTable .strTable .strTable td:first-child .name::before {left: 50px;}
.line .strTable .strTable .strTable .strTable .strTable td:first-child .name::before {left: 60px;}
.line .strTable .strTable .strTable .strTable .strTable .strTable td:first-child .name::before {left: 70px;}

.line .strTable li:first-child .name {padding-left: 30px;}
.line .strTable .strTable li:first-child .name {padding-left: 40px;}
.line .strTable .strTable .strTable li:first-child .name {padding-left: 50px;}
.line .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 60px;}
.line .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 70px;}
.line .strTable .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 80px;}

.line .strTable .strTable .moreBtn {margin-left: 10px;}
.line .strTable .strTable .strTable .moreBtn {margin-left: 20px;}
.line .strTable .strTable .strTable .strTable .moreBtn {margin-left: 30px;}
.line .strTable .strTable .strTable .strTable .strTable .moreBtn {margin-left: 40px;}
.line .strTable .strTable .strTable .strTable .strTable .strTable .moreBtn {margin-left: 50px;}

#PTtab-4 .line .strTable li:first-child .name {padding-left: 20px;}

.name {padding-left: 10px;text-align: left;display: flex; align-items: center; gap: 5px;}
.name span {display: inline-block;font-size: 12px;color: #000000;margin-bottom: 5px;}
.name em {display: block;color: #000000;margin-top: 5px;}
.lRoll span:first-child {margin-bottom: 6px;}
.lRoll span {display: block;text-align: left;padding-left: 5px;}
.lRoll input {width: 45px;margin: 0 3px;}
.userBetBtn {border: 1px solid #2F4DF2;background: #6980FC;border-radius: 5px;font-size: 12px;padding: 5px 20px;display: inline-block;cursor: pointer;position: absolute;top: 5px;color:#fff;}
.userBetWrap {position: fixed;top: 50%;left: 50%;transform: translate(-50%,-50%);background: #fff;padding: 0 0 70px;border: 2px solid #777;z-index: 1;width: 100%;max-width: 1200px; min-height: 500px; max-height: 820px;}
.userBetWrap .close {position: absolute;right: 20px;top: 20px;cursor: pointer;display: inline-block;width: 30px; height: 30px; background: url(../../../assets/img/icon_cancelB.svg) no-repeat; background-size: contain;}
.userBetWrap .close img {height: 25px;}
.userBetWrap h4 {font-size: 20px;font-weight: bold;margin: 40px 25px 25px;position: relative;color: #000;text-align: left;}
.userBetWrap .tab-content {max-width: 1600px;width: calc(100% - 25px);margin: 0 0 30px 25px;}
.userBetWrap > div {white-space:nowrap;overflow-x: auto;-webkit-overflow-scrolling: touch;-ms-overflow-style: -ms-autohiding-scrollbar;text-align:center;}
.userBetWrap > div::-webkit-scrollbar {display: none;}
.userBetWrap .board {width: 1150px;}
.gameName {background: #fff;border-radius: 5px;border: 1px solid #60452a;color: #000;margin: 0 25px 28px;height: 30px;padding: 0 10px;display: flex;justify-content: left;}

.mybetwrap .tabs{display: flex;align-items: center;justify-content: center;gap: 7px;margin: 0 25px 28px;}
.mybetwrap .tabs li{text-align: center;width: 100%;color: #60452a;cursor: pointer;font-size: 14px;border-radius: 10px;border: solid 1px #c5ad75;background-color: #fff;padding: 9px 0;}

.mybetwrap .board>.boardw.first:first-child {background: linear-gradient( to bottom, #c5ad75, #d3aa4b);color: #fff;border: 0;border-radius: 10px 10px 0 0;}
.mybetwrap .boardw:last-child {border-bottom: 1px dotted #60452a;}
.mybetwrap .boardw {width:100%;border-bottom: 1px dotted #60452a;background: #fff;display: flex;text-align: center;justify-content: space-around;align-items: center;height:45px;line-height: 1.5em;font-size: 14px;cursor: pointer;color: #000;box-sizing: border-box;}
.mybetwrap .boardw li{width:100%;display: flex;align-items: center;justify-content: center;line-height: 1.2em;overflow: hidden;}
.mybetwrap .boardw li a {color: #000;}

/*datesearch*/
.datesearchPT .datesearch {background:none !important;}
.datesearchPT .datesearch span {color:#000 !important;}
/* 등급 매장일 때 하부파트너목록 버튼 비활성화 */
.disabled { display: none; }

@media (max-width: 1000px) {
  .line {white-space: nowrap;overflow-x: auto;-webkit-overflow-scrolling: touch;-ms-overflow-style: -ms-autohiding-scrollbar;text-align: center;}
  .line .strTable li:first-child .name {padding-left: 10px;}
  .line .strTable .strTable li:first-child .name {padding-left: 10px;}
  .line .strTable .strTable .strTable li:first-child .name {padding-left: 10px;}
  .line .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 10px;}
  .line .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 10px;}
  .line .strTable .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 10px;}
  #PTtab-4 .line .strTable li:first-child .name {padding-left: 10px;}
}
@media screen and (max-width: 799px) {
  /* .line .strTable li:first-child .name {padding-left: 5px;}
  .line .strTable .strTable li:first-child .name {padding-left: 5px;}
  .line .strTable .strTable .strTable li:first-child .name {padding-left: 5px;}
  .line .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 5px;}
  .line .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 5px;}
  .line .strTable .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 5px;}*/
}
</style>

<style scoped>
.pb30 {padding-bottom:30px;}
.w100w {margin: 0 20px auto;min-width: 1314px;}
.nonebtn {background: none !important;border: 0 !important;width: auto !important;}
.rollname {font-size: 16px;color: #000;margin-bottom: 18px;}
.close {position: absolute;right: 15px;top: 15px;}
.board {box-shadow: 0 0px 6px 0 rgb(0 0 0 / 20%);border-radius: 0 0 10px 10px;}
.boardstrin .rollname {margin-top: 30px;}
.board.even .boardstr {background: #f8f9fb;}
.datesearchPT {display: flex;justify-content: space-between;align-items: center;}
.datesearchPT .btn {background: #fc7220;font-size: 14px;width: 93px;height: 28px;color: #fff;line-height: 28px;text-align: center;border-radius: 5px;margin-bottom: 18px;}
.searchPT {display: flex; gap:10px;}
.PTsch .searchPT h5{line-height: 30px;font-size: 14px;padding-left:120px}
.saveBtnPT {background: #2F4DF2;font-size: 14px;padding: 0 10px;height: 28px;color: #fff;line-height: 28px;text-align: center;border-radius: 5px;display: inline-block;}
.moveWrap {position: fixed;top: 50%;left: 50%;transform: translate(-50%,-50%);background: #fff;z-index: 5;font-family: 'NanumGothic';box-shadow: 0 0 10px 1px #ddd;}
.moveWrap .close {position: absolute;right: 50px;top: 18px;}
.moveWrap .close img {height: 28px;}
.moveWraphead { padding: 20px 50px; background:#575C68; color: #fff; font-size: 18px; }
.moveWrapbody { padding: 0 50px 20px; }
.moveWrap h4 {font-size: 16px;font-weight: bold;margin: 40px 0 18px;position: relative;color: #575C68;}
.moveWrap table {width: 800px;text-align: center;}
.moveWrap th {height: 40px;background: #828793; border: solid 1px #DDDEE2;color: #fff;vertical-align: middle;}
.moveWrap table tr:nth-child(2) th { background:#EEF0F5; color: #575C68; }
.moveWrap .scroll table tr:nth-child(2) th { background:#828793; color: #fff;}
.moveWrap td {height: 40px;background: #FBFCFD;vertical-align: middle;border: solid 1px #EEF0F5;white-space: nowrap;color: #575C68;overflow: hidden;text-overflow: ellipsis;position: relative;}
.moveWrap input {width: 50px;border: 1px solid #0000F0;background: #fff;border-radius: 3px;color: #575C68;text-align: center;}
.moveWrap input.in {width: 60%;height: 28px;}
.moveWrap input.in.password {-webkit-text-security: disc;-moz-webkit-text-security: disc;-moz-text-security: disc;}
.moveWrap input.add {width: 50%;height: 28px;}
.moveWrap input.add2 {width: 17%;height: 25px;border: 1px solid #fff;border-radius: 4px;padding-left: 5px;box-sizing: border-box;}
.moveWrap .accountInfo input.in { width: 54%; }
.moveWrap select.in {width: 80px;height: 28px;border: 1px solid #60452a;background: #fff;color: #575C68;margin-right: 5px;}
.moveWrap p {margin-top: 25px;color: #2A40B9;font-size: 12px;text-align: right;}
.moveWrap a.btn {margin-top: 25px;background: #2F4DF2;font-size: 16px;padding: 0 55px;height: 35px;color: #fff;line-height: 35px;text-align: center;border-radius: 5px;display: inline-block;margin-bottom: 18px;float: right;}
.rbnt {display: block;margin-bottom: 10px;}
.rbnt:first-child {margin-top: 10px;}
.error {border-color: #ff3f45 !important;}
.scroll {max-height: 400px;overflow-y: auto;}
.total td {background: #141414;}
.moreBtn.b {position: relative;border: solid 1px #fff;width: 50px;margin: 0 auto;}
@media screen and (max-width: 799px) {
  .moreBtn {box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: #2F4DF2;position: absolute;top: 0;left:0;width: 18px;height: 18px;cursor: pointer;transition: all 0.7s ease;font-size: 22px;border:1px solid #2F4DF2;border-radius: 3px;}
  .line .strTable li:first-child .name {padding-left: 0;}
  .line .strTable .strTable li:first-child .name {padding-left: 0;}
  .line .strTable .strTable .strTable li:first-child .name {padding-left: 0;}
  .line .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 0;}
  .line .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 0;}
  .line .strTable .strTable .strTable .strTable .strTable .strTable li:first-child .name {padding-left: 0;}
}

.makeWraphead h4 {border-top: 2px solid #fff;margin-top: 0 !important;padding-top: 20px;}
.groupTab {display: flex;gap: 5px;margin: 30px auto 0;width: 280px;color: #9f9999;}
.groupTab li {width: 100%;height: 33px;background: #353537;border: 1px solid #fff;border-bottom: 0;border-radius: 6px 6px 0 0;display: flex;align-items: center;justify-content: center;cursor: pointer;}
.groupTab li.current {background: #fff;color: #000;height: 33px;}

.moveWrap2 {position: fixed;top: 50%;left: 50%;transform: translate(-50%,-50%);background: #fff;z-index: 5;font-family: 'NanumGothic';box-shadow: 0 0 10px 1px #ddd;}
.moveWrap2 .close {position: absolute;right: 50px;top: 18px; cursor: pointer;}
.moveWrap2 .close img {height: 35px;}
.moveWraphead { padding: 20px 50px; background:#575C68; color: #fff; font-size: 18px; }
.moveWrapbody { padding: 0 50px 20px; }
.moveWrap2 h4 {font-size: 16px;font-weight: bold;margin: 40px 0 18px;position: relative;color: #575C68;}
.moveWrap2 table {width: 800px;text-align: center;}
.moveWrap2 th {height: 40px;background: #828793; border: solid 1px #DDDEE2;color: #fff;vertical-align: middle;}
.moveWrap2 table tr:nth-child(2) th { background:#EEF0F5; color: #575C68; }
.moveWrap2 .scroll table tr:nth-child(2) th { background:#828793; color: #fff;}
.moveWrap2 td {height: 40px;background: #FBFCFD;vertical-align: middle;border: solid 1px #EEF0F5;white-space: nowrap;color: #575C68;overflow: hidden;text-overflow: ellipsis;position: relative;}
.moveWrap2 input {width: 50px;border: 1px solid #0000F0;background: #fff;border-radius: 3px;color: #575C68;text-align: center;}
.moveWrap2 input.in {width: 90%;height: 28px;}
.moveWrap2 input.in.password {-webkit-text-security: disc;-moz-webkit-text-security: disc;-moz-text-security: disc;}
.moveWrap2 .accountInfo input.in { width: 54%; }
.moveWrap2 .accountInfo input.in.w45w {width: 45%;}
.moveWrap2 select.in {width: 80px;height: 28px;border: 1px solid #60452a;background: #fff;color: #575C68;margin-right: 5px;}
.moveWrap2 p {margin-top: 25px;color: #2A40B9;font-size: 12px;text-align: right;}
.moveWrap2 a.btn {margin-top: 25px;background: #2F4DF2;font-size: 16px;padding: 0 55px;height: 35px;color: #fff;line-height: 35px;text-align: center;border-radius: 5px;display: inline-block;margin-bottom: 18px;float: right;}
.tabmenu_make > ul {display: flex; gap: 10px; }
.tabmenu_make > ul li {border: 1px solid; border-radius: 10px; padding: 8px 15px; cursor: pointer; }
.tabmenu_make > ul li.current {background: #fff;color: #575C68;}
</style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
<style scoped src="@/styles/striNew.css"></style>

<style scoped>
.open h3 {height: 50px;display: flex;align-items: center;}
.closeMenu.open h3::after {content: '▲';}
.closeMenu h3::after {content: '▼';position: absolute;right: 20px;}
.open > div {height: auto !important;flex-wrap: wrap;}
.moneyBtn .lower-action-list {
  flex-direction: column;
}

/* 하부생성 팝업 DIM */
.makePopupDim {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 998;
}

/* 하부생성 팝업 */
.moveWrap2.makePopup {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 760px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 60px);
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 999;
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35);
}

/* 팝업 헤더 */
.moveWrap2.makePopup .moveWraphead {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 64px;
  padding: 0 22px;
  background: #575c68;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.moveWrap2.makePopup .tabmenu_make > ul {
  display: flex;
  gap: 8px;
  margin: 0;
}

.moveWrap2.makePopup .tabmenu_make > ul li {
  min-width: 86px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #fff;
  border-radius: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.moveWrap2.makePopup .tabmenu_make > ul li.current {
  background: #fff;
  color: #575c68;
}

.moveWrap2.makePopup .close {
  position: static;
  cursor: pointer;
}

.moveWrap2.makePopup .close img {
  width: 26px;
  height: 26px;
}

/* 팝업 본문 */
.moveWrap2.makePopup .moveWrapbody {
  padding: 24px 30px 28px;
}

.moveWrap2.makePopup h4 {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: bold;
  color: #363b72;
}

.moveWrap2.makePopup table.part {
  width: 100%;
  border-collapse: collapse;
}

.moveWrap2.makePopup table.part tr {
  display: grid;
  grid-template-columns: 120px 1fr 120px 1fr;
  gap: 8px 12px;
  align-items: center;
  margin-bottom: 10px;
}

.moveWrap2.makePopup table.part th,
.moveWrap2.makePopup table.part td {
  height: auto;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  color: #111;
}

.moveWrap2.makePopup table.part th {
  font-size: 13px;
  font-weight: bold;
  color: #555;
}

.moveWrap2.makePopup input.in,
.moveWrap2.makePopup select.in {
  width: 100% !important;
  height: 34px !important;
  border: 1px solid #d8dbe3 !important;
  border-radius: 6px !important;
  padding: 0 10px !important;
  box-sizing: border-box;
}

.moveWrap2.makePopup .accountInfo {
  display: flex;
  gap: 6px;
}

.moveWrap2.makePopup .accountInfo select {
  flex: 0 0 95px;
}

.moveWrap2.makePopup .accountInfo input {
  flex: 1;
}

.moveWrap2.makePopup a.btn {
  float: none;
  width: 160px;
  height: 38px;
  margin: 22px 0 0 auto;
  padding: 0;
  border-radius: 8px;
  background: #363b72;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 모바일 */
@media (max-width: 1000px) {
  .moveWrap2.makePopup {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    max-height: calc(100vh - 40px);
    border-radius: 12px;
  }

  .moveWrap2.makePopup .moveWraphead {
    height: auto;
    min-height: 58px;
    padding: 12px;
  }

  .moveWrap2.makePopup .tabmenu_make > ul li {
    min-width: 74px;
    height: 32px;
    font-size: 12px;
  }

  .moveWrap2.makePopup .moveWrapbody {
    padding: 18px 15px 22px;
  }

  .moveWrap2.makePopup table.part tr {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 12px;
  }

  .moveWrap2.makePopup table.part th,
  .moveWrap2.makePopup table.part td {
    width: 100% !important;
  }

  .moveWrap2.makePopup table.part th {
    font-size: 12px;
  }

  .moveWrap2.makePopup input.in,
  .moveWrap2.makePopup select.in {
    height: 38px !important;
  }

  .moveWrap2.makePopup .accountInfo {
    flex-direction: column;
  }

  .moveWrap2.makePopup .accountInfo select,
  .moveWrap2.makePopup .accountInfo input {
    width: 100% !important;
    flex: none;
  }

  .moveWrap2.makePopup a.btn {
    width: 100%;
    height: 42px;
    margin-top: 18px;
  }
}
/* 추천인/계좌정보 영역 정렬 보정 */
.moveWrap2.makePopup table.part td {
  min-width: 0;
}

.moveWrap2.makePopup table.part td:not(.accountInfo) {
  word-break: keep-all;
  white-space: nowrap;
}

.moveWrap2.makePopup table.part input.in {
  min-width: 0 !important;
}
.moveWrap2.makePopup .accountInfo {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 6px;
  align-items: center;
}

.moveWrap2.makePopup .accountInfo select.in,
.moveWrap2.makePopup .accountInfo input.in {
  width: 100% !important;
  min-width: 0 !important;
}

@media (min-width: 1001px) {
  .moveWrap2.makePopup table.part tr {
    grid-template-columns: 100px minmax(180px, 1fr) 100px minmax(180px, 1fr);
  }
}
.open .openMenu {display: flex;}
.openMenu {display: none;flex-direction: column;width: 100%;gap: 22px;padding: 0 0 11px 15px;font-weight: normal;}

.openMenu a:hover, .openMenu .on {color: #f67b0c;}

li:nth-child(1) .openMenu .on, li:nth-child(1) .openMenu a:hover {color: #2ea4c3;}
li:nth-child(2) .openMenu .on, li:nth-child(2) .openMenu a:hover {color: #dfbb4c;}
li:nth-child(3) .openMenu .on, li:nth-child(3) .openMenu a:hover {color: #db3e44;}
li:nth-child(4) .openMenu .on, li:nth-child(4) .openMenu a:hover {color: #bf77ce;}
li:nth-child(5) .openMenu .on, li:nth-child(5) .openMenu a:hover {color: #78c2b0;}

.topBtn {gap: 10px !important;}
.topBtn a {display: flex;align-items: center;justify-content: center;padding: 0 15px;height: 34px;box-sizing: border-box;font-size: 14px;border-radius: 3px;box-shadow: inset 0 -3px 3px 0 rgba(0, 0, 0, 0.35);background-image: linear-gradient(to bottom, #e6e6e6 100%, #909090 0%);text-shadow: 0 2px 3px rgba(0, 0, 0, 0.45);}
.topBtn a:hover {background-image: linear-gradient(104deg, #f1582c, #e20e85);color: #fff;}
.topInfo-wrap {display: flex;flex-direction: row-reverse;gap: 10px;}
.topInfo {display: flex;align-items: center;justify-content: end;gap: 10px;}
.topInfo > div {display: flex;flex-direction: column;align-items: center;justify-content: center;gap: 5px;width: 135px;height: 45px;border-radius: 3px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);background-color: #363636;font-size: 12px;color: #fff;}
.topInfo em {display: flex;align-items: center;gap: 4px;}
.topInfo img {width: 16px;}
.topInfo span {font-size: 14px;}
.logoutwrap {align-items: center !important;}
.loginbtn {cursor: pointer;color: #fff;font-size: 12px;border: 0;background: none; padding: 0;width: 18px;}
@media (min-width: 1001px) {
  .loginbtn.edit img {display: block;}
}
.loginbtn.edit {
  background: url('../../../assets/img/icon_set.svg') no-repeat;
  width: 20px;height: 20px;
  background-size: cover;
}
.loginbtn.logout {
  /*background: url('../../../assets/img/icon_logout.svg') no-repeat;*/
  width: 65px;height: 25px;
  border: 1px solid #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1500px) {
  .topInfo > div {width: 136px;}
  .topInfo span {font-size: 18px;}
  .topBtn {flex-direction: row !important;font-size: 12px !important;gap: 5px !important;}
  .topBtn a {padding: 0 5px;font-size: 12px;height: 30px;}
  .topInfo-wrap {gap: 4px;}
  .topInfo {gap: 5px;}
  .topInfo > div {width: 100%;height: 30px;font-size: 12px;padding: 0 5px;flex-direction: row;justify-content: space-between;}
  .topInfo em i {display: none;}
  .topInfo span {font-size: 12px;}
}
@media screen and (max-width: 1080px) {
  .topInfo-wrap {flex-direction: column;}
  .topBtn {font-size: 11px !important;gap: 3px !important;}
  .topBtn a {padding: 0 2px;height: 26px;font-size: 11px;}
  .topInfo {padding: 0 5px;gap: 3px;}
  .topInfo > div {font-size: 11px;}
}
@media screen and (max-width: 450px) {
  .topBtn a {font-size: 9px;}
}

.loginWrap{display: flex;align-items: center;}
.logindropbtn {border: none;cursor: pointer;}
.langsp {display: flex;align-items: center;gap: 5px;font-size: 12px;color: #fff;}
.langsp img, .logindropdown-content img {height: 15px;}
.langsp .mn, .logindropdown-content .mn {width: 22px; height: 15px;}
.logindropdown {position: relative;display: inline-block;}
.logindropdown-content {display: flex;flex-direction: column;gap: 5px;font-size: 12px;padding: 5px;box-sizing: border-box;border: 1px solid #fff;border-radius: 4px;position: absolute;right: 0;background-color: #2a2d34;box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);z-index: 2;}
.langbtn {padding: 3px 5px;border: 1px solid #fff;border-radius: 4px;color: #8e8e8e;font-size: 14px;background: none;}
.logindropdown-content a {color: #f1f1f1;display: flex;align-items: center;gap: 5px;}
.logindropdown-content a:hover, .logindropdown-content .on {background-color: #575757;}
/* .logindropdown:hover .logindropdown-content {display: block;} */
#PTpage .navWrap .nav-bottom .content-wrap {
  overflow: hidden;
}

#PTpage .navWrap .nav-bottom .content-wrap .menu-title {
  position: relative;
  z-index: 2;
}

#PTpage .navWrap .nav-bottom .content-wrap .menu-contents {
  display: block !important;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
  transform: translateX(0) !important;
  transition: max-height 0.2s ease, opacity 0.14s ease;
  will-change: max-height, opacity;
  pointer-events: none;
}

#PTpage .navWrap .nav-bottom .content-wrap.active .menu-contents {
  max-height: 520px;
  opacity: 1;
  pointer-events: auto;
}

#PTpage .navWrap .nav-bottom .menu-contents > ul {
  margin: 0 !important;
  padding: 4px 0 9px !important;
  transform: translateX(0) !important;
}

#PTpage .navWrap .nav-bottom .menu-contents li {
  margin: 0 !important;
  padding: 0 !important;
  transform: translateX(0) !important;
  left: auto !important;
}

#PTpage .navWrap .nav-bottom .menu-contents .supMenu {
  display: flex !important;
  align-items: center;
  width: 100%;
  min-height: 30px;
  padding: 0 14px 0 34px !important;
  box-sizing: border-box;
  transform: translateX(0) !important;
  margin-left: 0 !important;
  left: auto !important;
  white-space: nowrap;
  transition: color 0.15s ease, background-color 0.15s ease;
}

#PTpage .navWrap .nav-bottom .content-wrap .menu-title .fa-chevron-right,
#PTpage .navWrap .nav-bottom .content-wrap .menu-title .fas.fa-chevron-right {
  flex: 0 0 auto;
  transform: rotate(0deg) !important;
  transition: transform 0.18s ease;
}

#PTpage .navWrap .nav-bottom .content-wrap.active .menu-title .fa-chevron-right,
#PTpage .navWrap .nav-bottom .content-wrap.active .menu-title .fas.fa-chevron-right {
  transform: rotate(90deg) !important;
}

@media (max-width: 1000px) {
  #PTpage .navWrap .nav-bottom .content-wrap .menu-contents .supMenu {
    padding-left: 30px !important;
  }
}
</style>
<style scoped>
.menu-icon {width: 16px;height: 16px;flex: 0 0 16px;fill: none;stroke: currentColor;stroke-width: 1.7;stroke-linecap: round;stroke-linejoin: round;}
</style>
<style scoped src="@/styles/sidebarDark.css"></style>
<style scoped src="@/styles/sidebarWhite.css"></style>
<style src="@/styles/partnerWhiteResponsive.css"></style>

<!-- 메인 대시보드: 태블릿/모바일 카드형 전용 CSS -->
<style>
@media (max-width: 1092px) {
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light { padding: 22px 14px 40px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .dashboard-hero { margin-bottom: 16px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .dashboard-hero h1 { margin: 0 !important; padding: 6px 0 4px !important; font-size: 28px !important; line-height: 1.15 !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap { display: block !important; margin-top: 18px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap .pt-dashth { width: 100% !important; margin: 0 0 10px !important; padding: 0 !important; display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 10px !important; list-style: none !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap .pt-dashth + .pt-dashth { margin-top: 10px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap .pt-dashth .pt-dash-card { width: auto !important; min-width: 0 !important; height: 104px !important; min-height: 104px !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; box-sizing: border-box !important; border: 1px solid #e2e8f0 !important; border-top: 4px solid #ff9843 !important; border-radius: 2px !important; background: #ffffff !important; box-shadow: 0 3px 10px rgba(15, 23, 42, 0.10) !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card.bet { border-top-color: #43bf5f !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card.new { border-top-color: #5c9df5 !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist { width: 100% !important; height: 100% !important; margin: 0 !important; padding: 0 !important; display: block !important; list-style: none !important; background: #ffffff !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist li:not(:first-child) { display: none !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist li:first-child { width: 100% !important; height: 100% !important; min-height: 0 !important; margin: 0 !important; padding: 13px 8px 12px !important; display: flex !important; flex-direction: column !important; align-items: center !important; justify-content: center !important; gap: 12px !important; box-sizing: border-box !important; border: 0 !important; background: transparent !important; color: #2f3f56 !important; font-size: 13px !important; font-weight: 800 !important; line-height: 1.25 !important; text-align: center !important; word-break: keep-all !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist li:first-child span { display: block !important; width: 100% !important; margin: 0 !important; color: #172033 !important; font-size: 28px !important; font-weight: 900 !important; line-height: 1 !important; letter-spacing: -0.04em !important; text-align: center !important; white-space: normal !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-panel { margin-top: 18px !important; }
}
@media (max-width: 520px) {
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light { padding: 20px 12px 36px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap .pt-dashth { gap: 9px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card { height: 98px !important; min-height: 98px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist li:first-child { gap: 10px !important; padding: 11px 6px !important; font-size: 12px !important; }
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dash-card .pt-dashlist li:first-child span { font-size: 26px !important; }
}
@media (max-width: 340px) {
  #PTpage.partner-dark-layout.partner-white-responsive .PTboardwrap .pt-dashboard-light .pt-dashwrap .pt-dashth { grid-template-columns: 1fr !important; }
}
</style>

<style>
.sidebar-mobile-shortcuts {
  display: none;
}
@media (max-width: 1092px) {
  #PTpage.partner-white-responsive #PTheadWrap .coninpointPT,
  #PTpage.partner-white-responsive #PTheadWrap .topBtn {
    display: none !important;
  }
  #PTpage.partner-white-responsive #PTheadWrap .topInfo-wrap {
    width: 100% !important;
    justify-content: flex-end !important;
  }
  #PTpage.partner-white-responsive #PTheadWrap .topInfo {
    width: min(100%, 430px);
  }
  #PTpage.partner-white-responsive .PTtabWrap.navWrap .sidebar-mobile-shortcuts {
    display: block !important;
    margin: 12px 14px 8px !important;
    padding: 12px !important;
    border: 1px solid rgba(148, 163, 184, 0.26) !important;
    border-radius: 10px !important;
    background: rgba(15, 23, 42, 0.35) !important;
    box-sizing: border-box !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__title {
    margin: 0 0 9px !important;
    color: #cbd5e1 !important;
    font-size: 12px !important;
    font-weight: 800 !important;
    letter-spacing: -0.02em;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 7px !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a {
    min-width: 0 !important;
    min-height: 38px !important;
    padding: 7px 8px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 5px !important;
    border: 1px solid rgba(191, 219, 254, 0.22) !important;
    border-radius: 7px !important;
    background: rgba(51, 65, 85, 0.84) !important;
    color: #f8fafc !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    line-height: 1.25 !important;
    text-align: center !important;
    word-break: keep-all !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
    transition: background-color 0.16s ease, border-color 0.16s ease;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a:hover,
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a:active {
    border-color: rgba(96, 165, 250, 0.9) !important;
    background: #334e78 !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a i {
    flex: 0 0 auto;
    font-size: 14px !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a:last-child {
    grid-column: 1 / -1 !important;
  }
}
@media (max-width: 520px) {
  #PTpage.partner-white-responsive .PTtabWrap.navWrap .sidebar-mobile-shortcuts {
    margin: 10px 10px 7px !important;
    padding: 10px !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid {
    gap: 6px !important;
  }
  #PTpage.partner-white-responsive .sidebar-mobile-shortcuts__grid > a {
    min-height: 36px !important;
    padding: 6px !important;
    font-size: 10.5px !important;
  }
}
</style>

<style>
/* 생성 팝업이 열리면 사이드바는 v-if로 DOM에서 제거되고, 팝업은 헤더보다 위에 표시된다. */
#PTpage.partner-popup-open #header.partner-tophead {
  z-index: 1 !important;
}

.makePopupDim {
  /*z-index: 30000 !important;*/
}

.moveWrap.makeWrap,
.moveWrap2.makePopup {
  /*z-index: 30001 !important;*/
}
</style>
